<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('finance_reports')" :is-filter="false">
        </Header>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('finance_reports')" :is-filter="false">
        </HeaderMobile>
      </template>
      <div class="row data-form">
        <div class="col-12">
          <ValidationObserver ref="form">
            <div class="row">
              <div class="col-12 col-sm-6">
                <ValidationProvider name="report" rules="required" v-slot="{valid, errors}">
                  <b-form-group :label="$t('report')">
                    <multi-selectbox :allow-empty="false" :multiple="false"
                                     :validate-error="errors[0]" :options="reportOptions"
                                     v-model="form.report"></multi-selectbox>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-12 col-sm-6">
                <ValidationProvider name="response_type" rules="required" v-slot="{valid, errors}"
                                    v-if="showReportType">
                  <b-form-group :label="$t('report_type')">
                    <multi-selectbox :allow-empty="false" :multiple="false"
                                     :validate-error="errors[0]" :options="responseTypeOptions"
                                     v-model="form.response_type"></multi-selectbox>
                  </b-form-group>
                </ValidationProvider>
              </div>

              <div class="col-12">
                <div class="row">
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showPeriod">
                    <ValidationProvider name="period_id" rules="" v-slot="{valid, errors}">
                      <b-form-group :label="$t('period')">
                        <payment-periods-selectbox
                            :multiple="true"
                            :semesters="semesters"
                            :validate-error="errors[0]"
                            v-model="form.period_id">
                        </payment-periods-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showCurrency">
                    <ValidationProvider name="currency" rules="required" v-slot="{valid, errors}">
                      <b-form-group :label="$t('currency')">
                        <multi-selectbox
                            :multiple="isCurrecyMultiple"
                            :options="computedCurrencies"
                            :validate-error="errors[0]"
                            v-model="form.currency">
                        </multi-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showDates">
                    <ValidationProvider name="start_date" rules="required">
                      <b-form-group :label="$t('start_date')">
                        <select-date
                            v-model="form.start_date">
                        </select-date>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="date">
                    <ValidationProvider name="due_date_before" rules="required">
                      <b-form-group :label="$t('date')">
                        <select-date
                            v-model="form.due_date_before">
                        </select-date>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showDates">
                    <ValidationProvider name="end_date" rules="required">
                      <b-form-group :label="$t('end_date')">
                        <select-date
                            v-model="form.end_date">
                        </select-date>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <!--                                    <b-col sm="6" md="4" lg="4" xl="3">-->
                  <!--                                        <b-form-group :label="$t('exam_date')">-->
                  <!--                                            <b-form-input type="date" v-model="datatable.queryParams.filter.date"/>-->
                  <!--                                        </b-form-group>-->
                  <!--                                    </b-col>-->

                  <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showSemester">
                    <ValidationProvider name="semester_id" rules="" v-slot="{valid, errors}">
                      <b-form-group :label="$t('registration_semester')">
                        <semesters-selectbox
                            :validate-error="errors[0]"
                            v-model="form.semester_id">
                        </semesters-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="col-6 col-xs-12" v-if="showNumbers">
                <ValidationProvider name="number" rules="" v-slot="{valid, errors}">
                  <b-form-group :label="$t('student_numbers')">
                    <lined-textarea v-model="form.number"
                                    :nowrap="false"
                                    :disabled="false"
                                    :styles="{ height: '15em', resize: 'both' }"
                                    :validateError="errors[0]">
                    </lined-textarea>
                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                  </b-form-group>
                </ValidationProvider>
              </div>

              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <processing-button @click="send" label="get_report"
                                   :processing="processing"></processing-button>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </app-layout>
  </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox";
import FinanceReportService from "@/services/FinanceReportService";
import ProcessingButton from "@/components/elements/ProcessingButton";
import LinedTextarea from "../../../components/elements/LinedTextarea";
import SemestersSelectbox from "../../../components/interactive-fields/SemestersSelectbox";
import qs from "qs";

export default {
  components: {
    SemestersSelectbox,
    LinedTextarea,
    ProcessingButton,
    PaymentPeriodsSelectbox,
    MultiSelectbox,
    AppLayout,
    ValidationProvider,
    ValidationObserver,
    Header,
    HeaderMobile
  },
  metaInfo() {
    return {
      title: this.$t('finance_reports')
    }
  },
  data() {
    return {
      showPeriod: false,
      showCurrency: false,
      isCurrecyMultiple: false,
      showDates: false,
      showSemester: false,
      showNumbers: false,
      showReportType: true,
      date: false,
      form: {
        response_type: 'excel'
      },
      reportOptions: [
        {value: '1', text: this.$t('aging_summary_report')},
        {value: '2', text: this.$t('collection_report')},
        {value: '3', text: this.$t('bank_reconciliation')},
        {value: '4', text: this.$t('cash_flow_report')},
      ],
      responseTypeOptions: [
        // {value: 'page', text: this.$t('page')},
        {value: 'excel', text: this.$t('excel')},
        // {value: 'pdf', text: 'PDF'},
      ],
      processing: false,
      reportName: "",
      semesters: null,
      currencies: [
        {value: null, text: this.$t('select')},
        {value: 'USD', text: 'USD'},
      ],
      showAllTL: false
    }
  },
  methods: {
    async send() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        this.processing = true;
        this.reportName = this.getOptionText(this.reportOptions, this.form.report);
        let config = {params: this.form};
        let isArrayBuffer = true;
        config.responseType = 'arraybuffer';
        let oldNumber = this.form.number;
        if (oldNumber) {
          config.params.number = config.params.number.split(/\n/);
        }
        if (this.form.report == '1' && this.checkPermission('report_numberofstudents')) {
          let data = {
            params: {
              filter: {
                due_date_before: this.form.due_date_before
              },
              response_type: 'excel',
            },
            paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            responseType: "arraybuffer"
          }
          FinanceReportService.agingSummaryReport(data).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '2' && this.checkPermission('paymentplan_collectionreport')) {
          let data = {
            params: {
              filter: {
                semester_id: this.form.semester_id,
              },
              response_type: 'excel',
            },
            paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            responseType: "arraybuffer"
          }
          FinanceReportService.collectionReport(data).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '3' && this.checkPermission('payment_bankreconciliationreport')) {
          let data = {
            params: {
              start_date: this.form.start_date,
              end_date: this.form.end_date,
              response_type: 'excel',
            },
            paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            responseType: "arraybuffer"
          }
          FinanceReportService.financeReconciliation(data).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        }
        else if (this.form.report == '4' && this.checkPermission('paymentplan_cashflowreport')) {
          let data = {
            params: {
              filter: {
                due_date_before: this.form.due_date_before
              },
              response_type: 'excel',
            },
            paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            responseType: "arraybuffer"
          }
          FinanceReportService.cashFlowReport(data).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        }
        this.form.number = oldNumber;
      }
    },
    callback(response) {
      if (this.form.response_type == 'page') {
        this._openFile(response);
      } else if (this.form.response_type == 'excel') {
        this._downloadFile(response, this.reportName + '.xlsx');
      } else if (this.form.response_type == 'pdf') {
        this._downloadFile(response, this.reportName + '.pdf');
      }
    }
  },
  watch: {
    'form.report'(newVal, oldVal) {

      if (newVal != oldVal) {
        this.form = {response_type: 'page', report: newVal}
      }
      this.date = false
      this.showDates = false;
      this.showPeriod = false;
      this.showCurrency = false;
      this.showReportType = true;
      this.semesters = null;
      this.showAllTL = false;
      this.showNumbers = false;
      this.isCurrecyMultiple = false;
      if (newVal == '1') {
        this.date = true
      }
      if (newVal == '2') {
        this.showSemester = true
      } else if (newVal == '3') {
        this.showDates = true
      }
      else if (newVal == '4') {
        this.date = true
      }
    }
  },
  computed: {
    computedCurrencies() {
      return this.currencies.filter((item) => {
        return item.value != 'TL' || this.showAllTL;
      })
    }
  }
};
</script>
